module.exports = __webpack_public_path__ + "static/media/excercies-image.1818cc1a.png";